// A doc board in small, for its tile in All boards: its page tree down the side and the page it opens on,
// in the board's own tile colors, laid out as the board lays them, so the zoom into it lands where they are.

import { treeRows } from "../../../shared/entries";
import type { Board, Entry } from "../../../shared/types";
import { cx } from "../../lib/util";
import { openOn, pageTitle, useDocUi } from "./state";

export function DocThumb({ board, entries }: { board: Board; entries: Entry[] }) {
  const pages = entries.filter((e) => e.t === "page");
  const open = openOn(pages, useDocUi((s) => s.open[board.id]));
  const rows = treeRows(pages).slice(0, 14);
  return (
    <div className="ov-doc">
      <div className="ov-doc-side">
        {rows.map(({ entry, depth }) => (
          <span key={entry.id} className={cx("ov-doc-row", entry.id === open?.id && "is-on")} style={{ paddingLeft: 6 + depth * 9 }}>
            {typeof entry.data.icon === "string" && entry.data.icon ? <i>{entry.data.icon}</i> : null}
            {pageTitle(entry)}
          </span>
        ))}
      </div>
      <div className="ov-doc-page">
        <b>{open ? `${typeof open.data.icon === "string" && open.data.icon ? `${open.data.icon} ` : ""}${pageTitle(open)}` : "No pages yet"}</b>
        <span />
        <span />
        <span className="is-short" />
      </div>
    </div>
  );
}
